import React, { useEffect, useState } from "react";
import "./Clock.css";

const Clock = () => {
  const [timeZone, setTimeZone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 100);
    return () => clearInterval(interval);
  }, []);

  const getTimeInZone = (zone) => {
    return new Date(new Date().toLocaleString("en-US", { timeZone: zone }));
  };

  const currentTime = getTimeInZone(timeZone);

  const h = currentTime.getHours();
  const m = currentTime.getMinutes();
  const s = currentTime.getSeconds();
  const date = currentTime.getDate();
  const month = currentTime.getMonth() + 1;
  const year = currentTime.getFullYear();
  const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const day = weekday[currentTime.getDay()];

  const hDeg = h * 30 + m * (360 / 720);
  const mDeg = m * 6 + s * (360 / 3600);
  const sDeg = s * 6;

  const dialLines = [];
  for (let i = 1; i < 60; i++) {
    dialLines.push(
      <div
        key={i}
        className="diallines"
        style={{
          transform: `rotate(${6 * i}deg)`,
          width: i % 5 === 0 ? "4px" : "2px",
          height: i % 5 === 0 ? "25px" : "15px",
        }}
      ></div>
    );
  }

  return (
    <div className="clock-wrapper">
      <div className="clock">
        <div>
          <div className="info date">
            {date}/{month.toString().padStart(2, "0")}/{year}
          </div>
        </div>

        <div className="info weekday">{day}</div>
        <div className="dot"></div>

        <div>
          <div className="hour-hand" style={{ transform: `rotate(${hDeg}deg)` }}></div>
          <div className="minute-hand" style={{ transform: `rotate(${mDeg}deg)` }}></div>
          <div className="second-hand" style={{ transform: `rotate(${sDeg}deg)` }}></div>
        </div>

        <div>
          <span className="h3">3</span>
          <span className="h6">6</span>
          <span className="h9">9</span>
          <span className="h12">12</span>
        </div>

        {dialLines}
      </div>
    </div>
  );
};

export default Clock;
